import toMap from '~/misc/toMap';

export default toMap([
  'TOAST_CHANGE',
  'TOAST_CLOSE',
]);



// WEBPACK FOOTER //
// ./src/modules/toast/types.js